(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
(function() {
  var STORAGE_KEY = 'dclare_recently_viewed_v1';
  var HISTORY_LIMIT = 12;
  var HISTORY_TTL = 30 * 24 * 60 * 60 * 1000;

  function normaliseHistoryItem(item, now) {
    if (typeof item === 'string') {
      return { handle: item, viewedAt: now };
    }
    if (!item || typeof item.handle !== 'string') {
      return null;
    }
    return {
      handle: item.handle,
      viewedAt: Number(item.viewedAt) || now
    };
  }

  function preferenceStorageAllowed() {
    try {
      if (
        window.Shopify &&
        window.Shopify.customerPrivacy &&
        typeof window.Shopify.customerPrivacy.preferencesProcessingAllowed === 'function'
      ) {
        return window.Shopify.customerPrivacy.preferencesProcessingAllowed();
      }
    } catch (error) {
      return false;
    }
    return true;
  }

  function rememberCurrentProduct(currentHandle) {
    if (!currentHandle || !preferenceStorageAllowed()) { return []; }

    try {
      var now = Date.now();
      var stored = JSON.parse(window.localStorage.getItem(STORAGE_KEY) || '[]');
      var history = Array.isArray(stored) ? stored : [];
      var seen = {};
      var previous = [];

      history.forEach(function(item) {
        var normalised = normaliseHistoryItem(item, now);
        if (!normalised || !normalised.handle || normalised.handle === currentHandle) { return; }
        if (now - normalised.viewedAt > HISTORY_TTL || seen[normalised.handle]) { return; }
        seen[normalised.handle] = true;
        previous.push(normalised);
      });

      previous.sort(function(a, b) { return b.viewedAt - a.viewedAt; });

      var nextHistory = [{ handle: currentHandle, viewedAt: now }]
        .concat(previous)
        .slice(0, HISTORY_LIMIT);
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(nextHistory));

      return previous.map(function(item) { return item.handle; });
    } catch (error) {
      return [];
    }
  }

  function parseMarkup(markup) {
    return new window.DOMParser().parseFromString(markup, 'text/html');
  }

  function localeRoot() {
    return window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root
      : '/';
  }

  function fetchMarkup(url) {
    return window.fetch(url, { credentials: 'same-origin' }).then(function(response) {
      if (!response.ok) { throw new Error('Request failed'); }
      return response.text();
    });
  }

  function fetchViewedCard(handle) {
    var url = localeRoot() + 'products/' + encodeURIComponent(handle) + '?section_id=dclare-recently-viewed-product';
    return fetchMarkup(url)
      .then(parseMarkup)
      .then(function(documentFragment) {
        return documentFragment.querySelector('[data-dclare-product-source="viewed"]');
      })
      .catch(function() { return null; });
  }

  function fetchRelatedCards(sectionElement) {
    return fetchMarkup(sectionElement.dataset.url)
      .then(parseMarkup)
      .then(function(documentFragment) {
        return Array.prototype.slice.call(
          documentFragment.querySelectorAll('[data-dclare-product-source="related"]')
        );
      })
      .catch(function() { return []; });
  }

  function fetchFallbackCards(currentGender) {
    var collectionHandle = 'dclare-bestsellers';
    if (currentGender === 'Women') {
      collectionHandle = 'women-bestsellers';
    } else if (currentGender === 'Men') {
      collectionHandle = 'mens-bestsellers';
    }
    var url = localeRoot() + 'collections/' + collectionHandle + '?section_id=dclare-recommendation-fallback';
    return fetchMarkup(url)
      .then(parseMarkup)
      .then(function(documentFragment) {
        return Array.prototype.slice.call(
          documentFragment.querySelectorAll('[data-dclare-product-source="fallback"]')
        );
      })
      .catch(function() { return []; });
  }

  function initialiseRecommendationSection(sectionElement) {
    if (!sectionElement || sectionElement.dataset.dclareInitialised === 'true') { return; }
    sectionElement.dataset.dclareInitialised = 'true';

    var currentHandle = sectionElement.dataset.dclareCurrentHandle || '';
    var currentGender = sectionElement.dataset.dclareCurrentGender || '';
    var targetCount = Math.max(1, parseInt(sectionElement.dataset.dclareTargetCount, 10) || 4);
    var recentHandles = rememberCurrentProduct(currentHandle).slice(0, 2);

    if (!preferenceStorageAllowed()) {
      var consentHandler = function(event) {
        if (!event.detail || !event.detail.preferencesAllowed) { return; }
        rememberCurrentProduct(currentHandle);
        document.removeEventListener('visitorConsentCollected', consentHandler);
      };
      document.addEventListener('visitorConsentCollected', consentHandler);
    }

    function loadSection() {
      var viewedRequests = recentHandles.map(fetchViewedCard);

      Promise.all([
        Promise.all(viewedRequests),
        fetchRelatedCards(sectionElement)
      ]).then(function(results) {
        var viewedCards = results[0].filter(Boolean);
        var relatedCards = results[1];
        var selectedCards = [];
        var usedHandles = {};
        var viewedCount = 0;

        function addCard(card, source) {
          if (!card || selectedCards.length >= targetCount) { return; }

          var handle = card.dataset.dclareProductHandle || '';
          var gender = card.dataset.dclareProductGender || '';
          if (!handle || handle === currentHandle || usedHandles[handle]) { return; }
          if (source !== 'viewed' && currentGender && gender !== currentGender) { return; }

          usedHandles[handle] = true;
          selectedCards.push(card);
          if (source === 'viewed') { viewedCount += 1; }
        }

        viewedCards.forEach(function(card) { addCard(card, 'viewed'); });
        relatedCards.forEach(function(card) { addCard(card, 'related'); });

        var completeSection = function(fallbackCards) {
          fallbackCards.forEach(function(card) { addCard(card, 'fallback'); });

          var shell = sectionElement.querySelector('[data-dclare-recommendation-shell]');
          var list = sectionElement.querySelector('[data-dclare-recommendation-list]');
          var title = sectionElement.querySelector('[data-dclare-recommendation-title]');
          if (!shell || !list || !title || selectedCards.length === 0) { return; }

          list.innerHTML = '';
          selectedCards.forEach(function(card) { list.appendChild(card); });

          title.textContent = title.dataset.defaultTitle || 'YOU MAY ALSO LIKE';

          shell.hidden = false;

          if (window.theme && window.theme.ProductBlockManager) {
            window.theme.ProductBlockManager.loadImages(sectionElement);
          }
          if (window.theme && typeof window.theme.initAnimateOnScroll === 'function') {
            window.theme.initAnimateOnScroll();
          }
        };

        if (selectedCards.length < targetCount) {
          fetchFallbackCards(currentGender).then(completeSection);
        } else {
          completeSection([]);
        }
      });
    }

    if ('IntersectionObserver' in window) {
      var observer = new window.IntersectionObserver(function(entries) {
        if (!entries.some(function(entry) { return entry.isIntersecting; })) { return; }
        observer.disconnect();
        loadSection();
      }, { rootMargin: '300px 0px' });
      observer.observe(sectionElement);
    } else {
      loadSection();
    }
  }

  function initialiseAllRecommendationSections() {
    document.querySelectorAll('.product-recommendations').forEach(initialiseRecommendationSection);
  }

  document.addEventListener('shopify:section:load', function(event) {
    var sectionElement = document.querySelector(
      '[data-section-id="' + event.detail.sectionId + '"].product-recommendations'
    );
    initialiseRecommendationSection(sectionElement);
  });

  initialiseAllRecommendationSections();
})();

  } catch(e) { console.error(e); }
})();
})();
